import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * WareDetail Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Color of buttons
     */
    @Prop() buttonColor!: string;

    /**
     * Product post
     */
    @Prop({ type: Object }) product!: {[k: string]: any};

    /**
     * Wares list
     */
    @Prop() wares!: Array<{[k: string]: any}>;

    /**
     * Active favorite Icon
     */
    @Prop({ type: Boolean }) favoriteIcon!: boolean;

    /**
     * Active Add To Cart
     */
    @Prop({ type: Boolean }) addToCart!: boolean;

    /**
     * Count of rate
     */
    @Prop({ type: [String, Number], default: 0 }) rateCount!: number | string;

    /**
     * Average of rate
     */
    @Prop({ type: [String, Number], default: 0 }) rateAverage!: number | string;

    /**
     * Base gutter for rate
     */
    @Prop({ default: 5 }) rateGutter!: number | string;
}
